import { createSlice } from '@reduxjs/toolkit';

import { submitImageSearch } from '@/redux/modules/search/imageSearch/imageSearch.actions';
import { defaultImageSearchSlice } from '@/redux/modules/search/imageSearch/imageSearch.types';

const imageSearchSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(submitImageSearch.pending, (slice) => {
            slice.status = 'analysing';
            slice.error = null;
            slice.results = [];
            slice.thumbnailUrl = null;
        });
        builder.addCase(submitImageSearch.fulfilled, (slice, { payload }) => {
            slice.status = 'success';
            slice.error = null;
            slice.results = payload.results;
            slice.thumbnailUrl = payload.thumbnailUrl;
        });
        builder.addCase(submitImageSearch.rejected, (slice, { payload }) => {
            slice.status = 'error';
            slice.error = payload ?? 'request-failed';
            slice.results = [];
            slice.thumbnailUrl = null;
        });
    },
    initialState: defaultImageSearchSlice,
    name: 'imageSearch',
    // Object-URL revocation lives in useImageSearch (component layer) so this reducer stays pure.
    reducers: {
        resetImageSearch: () => defaultImageSearchSlice,
    },
});

export const { resetImageSearch } = imageSearchSlice.actions;
export const { reducer: imageSearchReducer } = imageSearchSlice;
